module.exports = __webpack_public_path__ + "static/img/live-video-bg.bae40bed.png";